// Вкладка «История изменений»: кто, когда, какое поле, из чего во что.
//
// ЗАЧЕМ ИМЕННО ЧЕТЫРЕ КОЛОНКИ. «Сделку изменил Петров» не отвечает ни на один вопрос,
// ради которого журнал открывают. Открывают его в двух случаях: «почему тут стоит эта
// сумма» и «кто перевёл сделку в проигрыш». На оба отвечает только пара «из чего во что»
// рядом с именем и временем.
//
// ПОЧЕМУ УДАЛЕНИЕ И ВОЗВРАТ ИДУТ С ПРИЧИНОЙ. В своей схеме причина обязательна для
// delete/restore — и это не формальность: запись, удалённая без объяснения, через месяц
// неотличима от записи, потерянной синком.

import { fmtDate } from '../lib/format'

import { поСвежести } from './history'
import type { ЗаписьЖурнала } from './types'
import type { Ответ } from './useSourceData'

const ПОДПИСЬ_ОПЕРАЦИИ: Record<string, string> = {
  create: 'Создана',
  update: 'Изменено',
  delete: 'Удалена',
  restore: 'Возвращена',
}

const ПОДПИСЬ_ОТКУДА: Record<string, string> = {
  ui: 'из CRM',
  api: 'по обмену',
  import: 'при переносе',
  job: 'фоновой задачей',
}

/** Данные приходят пропом: их же считает счётчик на полосе вкладок. */
export function HistoryTab({ ответ }: { ответ: Ответ<ЗаписьЖурнала[]> }) {
  const { данные, отказ, ждём } = ответ
  const записи = данные ? поСвежести(данные) : null

  return (
    <div className="card">
      <h2>Что менялось в карточке</h2>
      {отказ && (
        <div className="notice err">
          Журнал не пришёл: {отказ}. Пустая таблица здесь означала бы «карточку не меняли» —
          это не то же самое, поэтому мы её не показываем.
        </div>
      )}
      {!отказ && ждём && <div className="skeleton" />}
      {!отказ && !ждём && записи && записи.length === 0 && (
        <div className="empty">
          <div className="empty-title">Изменений не было</div>
          <div className="empty-hint">
            Карточку завели и с тех пор не правили. Это ответ «ноль», а не «журнал не работает».
          </div>
        </div>
      )}
      {!отказ && !ждём && записи && записи.length > 0 && (
        <div className="table-wrap cards">
          <table>
            <thead>
              <tr>
                <th>Когда</th>
                <th>Кто</th>
                <th>Что</th>
                <th>Из чего</th>
                <th>Во что</th>
              </tr>
            </thead>
            <tbody>
              {записи.map((з, i) => (
                <tr key={`${з.ревизия}-${з.поле ?? з.операция}-${i}`}>
                  <td data-label="Когда">{fmtDate(з.когда, true)}</td>
                  <td data-label="Кто">
                    {з.кто}
                    {з.откуда && з.откуда !== 'ui' && (
                      <span className="muted"> · {ПОДПИСЬ_ОТКУДА[з.откуда] ?? з.откуда}</span>
                    )}
                  </td>
                  <td data-label="Что">
                    {з.подписьПоля ?? ПОДПИСЬ_ОПЕРАЦИИ[з.операция] ?? з.операция}
                    {з.причина && <span className="muted"> · причина: {з.причина}</span>}
                  </td>
                  <td data-label="Из чего">{з.из ?? '—'}</td>
                  <td data-label="Во что">{з.во ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
